import { computed, onMounted } from 'vue'
import TeamBranding from '@/modules/teams/classes/TeamBranding'
import store from '@/store'
import fallbackBackgroundImage from '@/assets/background-kiswe-overlay.webp'
import { CssVariablesDict } from 'kiswe-ui'
import { getBrandingFromLocalData } from '@/modules/events/utils/teamBranding'

const useTeamBranding = (selector: string|null = null) => {
  const currentTeam = computed(() => store.state.team.team)
  const tempBranding = computed(() => store.state.team.tempBranding ?? getBrandingFromLocalData())
  const branding = computed(() => new TeamBranding(currentTeam.value?.branding ?? tempBranding.value))
  const isBranded = computed(() => !!branding.value?.logoUrl)
  const isBrandingLoaded = computed(() => {
    return !!currentTeam.value?.branding || !!tempBranding.value
  })

  const cssVariables = computed<CssVariablesDict>(() => {
    const bgImage = branding.value.backgroundImageUrl
      ? `url(${ branding.value.backgroundImageUrl })`
      : `url(${ fallbackBackgroundImage })`
    if (!isBranded.value) return { '--background-image': bgImage }
    return {
      '--background-image': bgImage,
      '--opacity': branding.value.backgroundImageUrl ? '0' : '0.85',
      '--font-default': branding.value.fontFamily ?? undefined,
      '--color-primary': branding.value.primaryColor ?? '',
      '--color-secondary': branding.value.secondaryColor ?? '',
      '--color-background': branding.value.backgroundColor ?? ''
    }
  })

  const cssVariablesBranded = computed<CssVariablesDict>(() => {
    const bgImage = branding.value.backgroundImageUrl
      ? `url(${ branding.value.backgroundImageUrl })`
      : `url(${ fallbackBackgroundImage })`
    if (!isBranded.value) return { '--background-image--branded': bgImage }
    return {
      '--background-image--branded': bgImage,
      '--opacity--branded': branding.value.backgroundImageUrl ? '0' : '0.85',
      '--font-default--branded': branding.value.fontFamily ?? undefined,
      '--color-primary--branded': branding.value.primaryColor ?? '',
      '--color-secondary--branded': branding.value.secondaryColor ?? '',
      '--color-background--branded': branding.value.backgroundColor ?? ''
    }
  })

  onMounted(() => {
    if (!isBranded.value || selector === null) return
    const elements = Object.values(document.querySelectorAll(selector)) as HTMLElement[]
    for (const el of elements) {
      el.style.setProperty('--color-primary', branding.value.primaryColor ?? '')
      el.style.setProperty('--color-secondary', branding.value.secondaryColor ?? '')
      el.style.setProperty('--color-background', branding.value.backgroundColor ?? '')
    }
  })

  return {
    branding,
    cssVariables,
    cssVariablesBranded,
    isBranded,
    isBrandingLoaded
  }
}

export default useTeamBranding
